import { Box, Grid, Skeleton } from '@mui/material';
import { FC } from 'react';

import { useLayout } from '../../hooks/useLayout';

//Скелетон карточки товара в сетку
const GridCatalogCardSkeleton: FC = () => {
  const { page } = useLayout();
  return (
    <Grid
      sx={{ display: 'grid', marginTop: '8px' }}
      rowGap={1}
      item
      xs={6}
      sm={4}
      md={page === 'catalog' ? 6 : 4}
      lg={page === 'catalog' ? 4 : 3}
    >
      <Skeleton animation="wave" variant="rounded" height={152} /> {/* Image */}
      <Skeleton animation="wave" variant="rounded" height={39} /> {/* Name */}
      <Skeleton
        animation="wave"
        variant="rounded"
        width={84}
        height={32}
      />{' '}
      {/* Price */}
      <Box sx={{ display: 'flex', columnGap: '8px' }}>
        <Skeleton animation="wave" variant="rounded" width="30%" height={36} />{' '}
        {/* Add in favorites */}
        <Skeleton
          animation="wave"
          variant="rounded"
          width="70%"
          height={36}
        />{' '}
        {/* Add in basket */}
      </Box>
      <Skeleton animation="wave" variant="rounded" height={44} /> {/* Vendor */}
    </Grid>
  );
};

export default GridCatalogCardSkeleton;
